import { Link } from 'react-router-dom';
import { Button, Box } from '@mui/material';
import PrintIcon from '@mui/icons-material/Print';
import LabelIcon from '@mui/icons-material/Label';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { RoutesEnum } from 'src/shared/models/enums/routes.enum';
import { ButtonContainedGrey } from 'src/shared/components/form/buttonContainedGrey';
import MemberExportButton from 'src/modules/member/components/memberExportButton';

const GridActionButtons = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '2px',
        '& > *': {
          ml: 1 / 2,
          mb: 1 / 2,
        },
      }}
    >
      <ButtonContainedGrey startIcon={<PrintIcon />}>Utskrift</ButtonContainedGrey>
      <ButtonContainedGrey startIcon={<LabelIcon />}>Etiketter</ButtonContainedGrey>
      <MemberExportButton />
      <Button
        variant='contained'
        color='primary'
        startIcon={<AddCircleIcon />}
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        component={Link as any}
        to={RoutesEnum.CreateSendingOrder}
        disableElevation
      >
        Beställ nytt utskick
      </Button>
    </Box>
  );
};

export default GridActionButtons;
